import { useContext, useMemo } from 'react'
import { TourV2PricePerDayDetails, extractTourV2PricePerDay } from 'lib/TourV2/extractTourV2PricePerDay'
import GeoContext from 'contexts/geoContext'
import CurrencyContext from 'contexts/currencyContext'

export function useTourV2PricePerDay(
  offer: Tours.V2Offer | Tours.V2OfferSummary,
  purchasableOption: Tours.V2OfferPurchasableOption,
  offerTypeDetail: Tours.V2OfferVariation | Tours.V2OfferDeparture,
  toursPricePerDayABTestVariation: string,
): TourV2PricePerDayDetails {
  const geo = useContext(GeoContext)
  const contextCurrency = useContext(CurrencyContext)
  const currencyCode = contextCurrency ?? geo.currentCurrency
  return useMemo(() => extractTourV2PricePerDay(offer, toursPricePerDayABTestVariation, purchasableOption, currencyCode, offerTypeDetail), [toursPricePerDayABTestVariation, offerTypeDetail, purchasableOption, currencyCode, offer])
}
